import Dexie from "dexie";

/**
 * IndexedDB Database Instance
 * Primary data source for offline functionality
 */
class OfflineDatabase extends Dexie {
  constructor() {
    super("BidzOfflineDB");

    this.version(1).stores({
      // PR Data - indexed by pr_token and pr_code for fast lookups
      purchaseRequests: "++id, pr_token, pr_code, lastSynced",

      // Master Data - indexed by their unique codes
      costCenters: "++id, costcenter_code, lastSynced",
      glCodes: "++id, gl_code, lastSynced",
      projectCodes: "++id, project_code, lastSynced",
      items: "++id, item_code, item_token, lastSynced",
      departments: "++id, name, lastSynced",
      vendors: "++id, token, lastSynced",
      users: "++id, token, lastSynced",
      prCodes: "++id, pr_code, lastSynced",

      // Offline Queue - indexed by timestamp for FIFO processing
      offlineQueue: "++id, timestamp, status, endpoint",

      // Generic Cache - key-value store for any API response
      cache: "key, lastSynced",
    });

    // Version 2: Add RFQ stores
    this.version(2).stores({
      // RFQ Data - indexed by rfq_token and org_token for fast lookups
      rfqs: "++id, rfq_token, org_token, lastSynced",

      // RFQ Details - individual RFQ information
      rfqDetails: "++id, rfq_token, lastSynced",

      // RFQ Bids - bids for each RFQ
      rfqBids: "++id, rfq_token, bid_token, lastSynced",

      // RFQ Messages - vendor and user messages
      rfqMessages: "++id, rfq_token, message_token, lastSynced",

      // Additional Master Data for RFQ
      countries: "++id, token, name, lastSynced",
      states: "++id, token, country_token, country_id, name, lastSynced",
      cities: "++id, token, state_token, state_id, name, lastSynced",
      shippingAddresses: "++id, buyer_token, lastSynced",
      rfqCategories: "++id, token, name, lastSynced",
      companies: "++id, token, name, lastSynced",
    });

    // Version 3: Add pagination support for RFQs
    this.version(3).stores({
      // RFQ Data - indexed by rfq_token, org_token, page, and filters for pagination
      rfqs: "++id, rfq_token, org_token, page, searchQuery, startDate, endDate, sortingColumn, sortingOrder, lastSynced",
      // Pagination metadata - store pagination info per page/filter combination
      rfqPagination:
        "++id, org_token, page, searchQuery, startDate, endDate, sortingColumn, sortingOrder, total_rfqs, current_page_count, page_count, lastSynced",

      // RFQ Details - individual RFQ information
      rfqDetails: "++id, rfq_token, lastSynced",

      // RFQ Bids - bids for each RFQ
      rfqBids: "++id, rfq_token, bid_token, lastSynced",

      // RFQ Messages - vendor and user messages
      rfqMessages: "++id, rfq_token, message_token, lastSynced",

      // RFQ Chat Timelines - chat history for vendor/user conversations
      rfqChatTimelines:
        "++id, rfq_token, vendor_token, user_token, message_id, lastSynced",

      // Additional Master Data for RFQ
      countries: "++id, token, name, lastSynced",
      states: "++id, token, country_token, country_id, name, lastSynced",
      cities: "++id, token, state_token, state_id, name, lastSynced",
      shippingAddresses: "++id, buyer_token, lastSynced",
      rfqCategories: "++id, token, name, lastSynced",
      companies: "++id, token, name, lastSynced",
    });
    
    // offline password
    this.version(4).stores({
      offlinePasswords:
        "++id, [user_token+device_id], user_token, device_id, version, active, lastSynced",
    });

    // Po automation

    this.version(5).stores({
      purchaseOrders: "PO_token, PO_number, lastSynced",
      pendingPOUpdates: "++id, PO_token, createdAt",
      pendingPODeletes:"++id,PO_token",
      syncMeta:"key"
    });
    
    // Rate contract

    this.version(14).stores({
      rateContract:"++id, rc_token ,rc_number,lastSynced",
      offlineRcPO: "++id, createdAt"
    })

    // GRN 
    this.version(7).stores({
      grnData: "++id, token, purchase_order_no, lastSynced",
      pendingGRNUpdates: "++id, token, createdAt",
      pendingGRNDeletes: "++id, token",
      syncMeta: "key"
    })

    /**get Purchase Order respon  **/


    this.version(8).stores({
      purchaseOrderData: "++id, purchase_order_id, purchase_order_no, lastSynced",
      pendingPurchaseOrderUpdates: "++id, purchase_order_id, createdAt",
      pendingPurchaseOrderDeletes: "++id, purchase_order_id",
      syncMeta: "key"
    })

    this.version(9).stores({
  threeWayMatching: "++id,token,match_code,lastSynced",
  pendingTwmActions:"++id,twm_token,action,createdAt"
});
this.version(10).stores({
  comparisonHistory: "token, prn_number, created_date, page, lastSynced",
  comparisonPagination: "++id, buyer_token, page, total_count, page_count, lastSynced",
  comparisonSyncMeta: "key"
});

this.version(11).stores({
  vendorMaster: "[org_token+token], org_token, company_name, created_on, lastSynced",
  vendorSyncMeta: "org_token,lastSyncedPage,totalPages"
});

    // Merchant invoice dashboard summary (unified API cache)
    this.version(12).stores({
      merchant_invoice_dashboard_summary: "org_id, org_token, organization, synced_at",
    });

    // Vendor invoice list/details (unified API cache)
    this.version(13).stores({
      vendor_invoice_list: "key, org_token, page, page_size, synced_at",
      vendor_invoice_details: "token, synced_at",
    });

    // GRN table cache for offline list view
    this.version(15).stores({
      grn_store:
        "grn_token, grn_number, purchase_order_no, invoice_number, created_at, overall_approval_status",
    });

    // GRN offline create dependencies and sync metadata
    this.version(16).stores({
      grn_store:
        "grn_token, grn_number, purchase_order_no, invoice_number, created_at, overall_approval_status, sync_status, offline_batch_id",
      users_store: "token, first_name, email, department",
      invoice_store: "invoice_number, pi_po_number, invoice_date",
    });
    
  }
}

// Singleton instance
export const db = new OfflineDatabase();

// Database initialization helper
export const initDatabase = async () => {
  try {
    await db.open();
    console.log("✅ IndexedDB initialized successfully");
  } catch (error) {
    console.error("❌ Failed to initialize IndexedDB:", error);
    throw error;
  }
};

// Clear all data (for testing/debugging)
export const clearAllData = async () => {
  try {
    await db.transaction("rw", db.tables, async () => {
      await Promise.all(db.tables.map((table) => table.clear()));
    });
    console.log("✅ All IndexedDB data cleared");
  } catch (error) {
    console.error("❌ Failed to clear IndexedDB:", error);
    throw error;
  }
};

// Get database size (for monitoring)
export const getDatabaseSize = async () => {
  if ("storage" in navigator && "estimate" in navigator.storage) {
    const estimate = await navigator.storage.estimate();
    return estimate.usage || 0;
  }
  return 0;
};
